import { productTypes } from '@fr/constants';

export type HotelPageFlow = 'tourOffer' | 'hotelOffer' | 'railwayTour';

const FLOW_BY_PRODUCT: Record<string, HotelPageFlow> = {
    [productTypes.TOUR_OFFER]: 'tourOffer',
    [productTypes.HOTEL_OFFER]: 'hotelOffer',
    [productTypes.RAILWAY_TOUR]: 'railwayTour',
};

export function getHotelPageFlow(searchSource?: string | null): HotelPageFlow {
    return FLOW_BY_PRODUCT[searchSource ?? ''] ?? 'tourOffer';
}
